var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{staticClass:"mt-3"},[_c('v-col',{attrs:{"cols":"12","sm":"12"}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-data-table',{attrs:{"headers":_vm.headersTable,"items":_vm.articleDiscountGroups,"page":_vm.page,"pageCount":_vm.numberOfPages,"options":_vm.options,"server-items-length":_vm.totalRecords,"footer-props":{
                                showFirstLastPage: true,
                                'items-per-page-options': [10, 20, 50],
                            }},on:{"update:options":function($event){_vm.options=$event}}})],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }